import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';
import type { Project, ProjectActivity } from 'types';
import type { ProjectActivitySummary } from 'types/ActivitySummary';

const getProjectSizeInformation = (slug: Project['slug']) => {
  return `/projects/${slug}/size-info/`;
};

const getProjectWorkType = (slug: Project['slug']) => {
  return `/projects/${slug}/work-type/`;
};

const getProjectLandTitleAssessmentValue = (slug: Project['slug']) => {
  return `/projects/${slug}/transaction-property-value/`;
};

const getProjectEvents = (
  slug: Project['slug'],
): Promise<AxiosResponse<ProjectActivity[]>> => {
  return api.get(`/project/${slug}/events/`);
};

const getProjectEventsSummary = (
  slug: Project['slug'],
): Promise<AxiosResponse<ProjectActivitySummary>> => {
  return api.get(`/project/${slug}/summary/`);
};

const getProjectTitles = (
  slugs: Project['slug'][],
): Promise<AxiosResponse<Project[]>> => {
  return api.post(`/project/title/bulk/`, {
    project_slugs: slugs,
  });
};

const getSectors = (): Promise<AxiosResponse<any[]>> => {
  return api.get('/v2/sectors/?static_fetch=true');
};

const getVerticals = (): Promise<AxiosResponse<any[]>> => {
  return api.get('/v2/verticals/?static_fetch=true');
};

export default {
  getProjectSizeInformation,
  getProjectWorkType,
  getProjectLandTitleAssessmentValue,
  getProjectEvents,
  getProjectEventsSummary,
  getProjectTitles,
  getSectors,
  getVerticals,
};
